module.exports = __webpack_public_path__ + "static/media/fwblog.63c28ef5.png";